export default __webpack_public_path__ + "static/media/green_marker_linear_spritesheet.c323f832.png";